export function stringToBoolAndNumber(str) {
  if (isNaN(parseInt(str))) {
    return str === 'true'
  }
  return str
}
